import { BaseDateCalculateExpression, DateSpanType } from "./BaseDateCalculateExpression";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { sub, subBusinessDays } from "date-fns";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DateSubtractXExpression extends BaseDateCalculateExpression {
    readonly __type: string = "Subtract from Date";

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let d = this.baseDate.evaluate(data, testContext) as Date;
        let adjustBy = this.adjustBy.evaluate(data, testContext) as number;

        switch (this.calculateType) {
            case DateSpanType.SECONDS:
                return sub(d, { seconds: adjustBy });
            case DateSpanType.MINUTES:
                return sub(d, { minutes: adjustBy });
            case DateSpanType.DAYS:
                return sub(d, { days: adjustBy });
            case DateSpanType.BUSINESS_DAYS:
                return subBusinessDays(d, adjustBy);
            case DateSpanType.WEEKS:
                return sub(d, { weeks: adjustBy });
            case DateSpanType.MONTHS:
                return sub(d, { months: adjustBy });
            case DateSpanType.YEARS:
                return sub(d, { years: adjustBy });
        }
    }
}
